import { MyOrganizationCommunity } from './MyOrganizationCommunity'
import BankingSetupPopupProvider from '../BankingSetupCommunity/Providers/BankingSetupPopupProvider'

export const MyOrganizationCommunityContainer = () => {
  return (
    <BankingSetupPopupProvider>
      <MyOrganizationCommunity />
    </BankingSetupPopupProvider>
  )
}
